<template src="./LikedProduct.html"></template>
<style lang="scss" scoped src="./LikedProduct.scss"></style>

<script>
import OrkLoader from "@/components/Ork/OrkLoader";
import {
  SfHeading,
  SfButton,
  SfImage
} from '@storefront-ui/vue';
import Api from "@/api/Api";

export default {
  name: "LikedProduct",
  components: {
    SfHeading,
    SfButton,
    SfImage,
    OrkLoader
  },

  data() {
    return {
      likedProduct: null,
      loading: false
    }
  },
  created() {
    this.getLikedProduct()
  },
  methods: {
    openLink(link) {
      window.open(link, "_self")
    },
    getLikedProduct() {
      this.loading = true
      Api.marketing.getHomeFeatured().then((data) => {
        this.likedProduct = data
      }).catch((e) => {

      }).finally(this.loading = false)
    }

  }

};
</script>